import { memo } from 'react'

import {
  TCallContainerProps,
  ReceivedCallContainer,
  CallOwnerContainer,
  CallRecipientContainer
} from 'App/containers'
import { PortalWrapper } from 'App/components'
import { VoiceRoom } from 'App/containers/Organizations/VoiceRoom'
import { useAppSelector } from 'store'

import { ExternalMeetingRoom } from '../ExternalMeetingRoom'

export type TCallWrapperProps = TCallContainerProps

export const CallWrapperView = ({
  isInitiatedCall,
  isAcceptedCall,
  isComingCall,
  activeVoiceRoom
}: TCallWrapperProps) => {
  const meetingSession = useAppSelector((state) => state.meetings.session)

  const callOwner = isInitiatedCall && !isAcceptedCall && !isComingCall
  const callRecipient = !isInitiatedCall && isAcceptedCall && !isComingCall
  const receivedCall = !isInitiatedCall && !isAcceptedCall && isComingCall

  const getContent = () => {
    if (activeVoiceRoom) {
      return <VoiceRoom />
    }

    if (meetingSession) {
      return <ExternalMeetingRoom />
    }

    if (callOwner) {
      return <CallOwnerContainer />
    }

    if (callRecipient) {
      return <CallRecipientContainer />
    }

    if (receivedCall) {
      return <ReceivedCallContainer />
    }

    return null
  }

  return (
    <>
      <PortalWrapper portalCssSelector="call-wrapper-portal">{getContent()}</PortalWrapper>
    </>
  )
}

export const CallWrapper = memo(CallWrapperView)
